import { render } from "./base-allowedaction-button.vue?vue&type=template&id=1d20c6fb&ts=true"
import script from "./base-allowedaction-button.vue?vue&type=script&lang=ts"
export * from "./base-allowedaction-button.vue?vue&type=script&lang=ts"

import "./base-allowedaction-button.vue?vue&type=style&index=0&id=1d20c6fb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__